import { useIntl } from "react-intl";
import Skeleton from "react-loading-skeleton";
import { IconCameraX } from "@tabler/icons-react";
import { AnyPeriod, classNames } from "@ct-react/core";
import { useLocaleFormatter } from "@ct-react/locale";
import { AgeCategory, CartPrice, Image } from "@shared/graphql";
import { pricing } from "../../i18n/sharable-defs";
import { SkeletonableProps } from "../../tools/components";
import RatioImage from "../medias/ratio-image";
import PeriodResumeInput from "../inputs/readonly/period";
import GuestsInput from "../article/aside/booking-inputs/guests";
import "./resume.scss";

type DataProps = {
  image?: Image;
  minGuests?: Partial<Record<AgeCategory, number>>;
  maxGuests?: number;
  guestable: boolean;
  period: AnyPeriod;
  guests?: Record<AgeCategory, number>;
  price?: CartPrice;
}

type Props = SkeletonableProps<DataProps> & {
  onGuestsChange?: (guests?: Record<AgeCategory, number>) => void;
}

const CheckoutResume = ({ loading, data, onGuestsChange }: Props) => {

  const intl = useIntl();
  const { print } = useLocaleFormatter();

  const wrapperClasses = classNames("cart-resume", { loading });

  if (loading || !data)
    return (
      <Skeleton containerClassName={wrapperClasses}
                style={{ borderRadius: "0px", height: "28.75rem" }} />);

  return (
    <div className={wrapperClasses}>
      <div className="preview">
        {!!data?.image
          ? <RatioImage source={data.image.assets} ratio="16/9" />
          : <IconCameraX className="x-icon" />
        }
      </div>
      <div className="inner">
        <PeriodResumeInput mode="theft" value={data.period} />
        {data.guestable && <GuestsInput sticked={false}
                                        withIcon={true}
                                        minGuests={data.minGuests}
                                        maxGuests={data.maxGuests}
                                        value={data.guests}
                                        onChange={onGuestsChange} />}
        {!!data?.price &&
          <dl className="amount">
            <dt>{intl.formatMessage(pricing.total)}</dt>
            <dd>{print.price(data.price.amount)}</dd>
          </dl>
        }
      </div>
    </div>);

};

export default CheckoutResume;
